if (!customElements.get('ambassador-card')) {
  class AmbassadorCard extends HTMLElement {
    connectedCallback() {
      this.front = this.querySelector('.amb-card__front');
      this.back = this.querySelector('.amb-card__back');
      if (!this.back) return;

      this.openButton = this.front.querySelector('[data-flip]');
      this.closeButton = this.back.querySelector('[data-flip]');

      this.setFlipped(false, false);
      this.querySelectorAll('[data-flip]').forEach((button) => {
        button.addEventListener('click', () => this.setFlipped(!this.classList.contains('is-flipped'), true));
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.classList.contains('is-flipped')) this.setFlipped(false, true);
      });
    }

    setFlipped(flipped, moveFocus) {
      this.classList.toggle('is-flipped', flipped);
      // La face cachée ne doit pas être atteignable au clavier ni lue par les lecteurs d'écran.
      this.front.inert = flipped;
      this.back.inert = !flipped;
      this.front.setAttribute('aria-hidden', flipped);
      this.back.setAttribute('aria-hidden', !flipped);
      if (this.openButton) this.openButton.setAttribute('aria-expanded', flipped);

      if (moveFocus) {
        const target = flipped ? this.closeButton : this.openButton;
        if (target) target.focus({ preventScroll: true });
      }
    }
  }

  customElements.define('ambassador-card', AmbassadorCard);
}

// Flèches précédent / suivant du défilement mobile
function initAmbassadorsNav(root) {
  root.querySelectorAll('[data-ambassadors-nav]').forEach((nav) => {
    if (nav.dataset.ready) return;
    const grid = document.getElementById(nav.dataset.ambassadorsNav);
    if (!grid) return;
    nav.dataset.ready = 'true';

    const [prev, next] = nav.querySelectorAll('button');
    const step = () => {
      const item = grid.querySelector('.ambassadors__item');
      return item ? item.offsetWidth + parseFloat(getComputedStyle(grid).columnGap || 0) : grid.clientWidth;
    };
    const update = () => {
      prev.disabled = grid.scrollLeft <= 2;
      next.disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 2;
    };

    nav.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        grid.scrollBy({ left: step() * Number(button.dataset.dir), behavior: 'smooth' });
      });
    });
    grid.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAmbassadorsNav(document));
} else {
  initAmbassadorsNav(document);
}
document.addEventListener('shopify:section:load', (event) => initAmbassadorsNav(event.target));
